/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export class AppHeaderNames {
    static readonly apiKey: string = "X-Api-Key";
    static readonly kioskId: string = "X-Kiosk-Id";
    static readonly kioskSessionId: string = "X-Kiosk-Session-Id";
}
